import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GRUPOS_APPS } from 'src/app/const/common/groups';
import { User } from 'src/app/models/auth/user';
import { UserSessionService } from './user-session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private _usuarioSesionService: UserSessionService,
    private _router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._usuarioSesionService.getToken()) {
      const user: User = this._usuarioSesionService.getToken();
      if (user.user_groups.includes(GRUPOS_APPS.GROUP_HERRALM)) {
        return true;
      } else {
        if (user.info_inicial && user.info_inicial.centroLogistico) {
          return true;
        } else {
          this._router.navigate(["auth/seleccion-inicial"]);
          return false;
        }
      }
    } else {
      this._router.navigate(["auth"]);
      return false;
    }
  }
}
